import { render } from "./Banque of Egypt club.vue?vue&type=template&id=be8b2de2&scoped=true"
const script = {}

import "./Banque of Egypt club.vue?vue&type=style&index=0&id=be8b2de2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be8b2de2"

export default script